function getTypeFormat(type, format) {
	if (format) {
		return format;
	} else {
		if (type === 'string') {
			return 'text';
		}
		return type;
	}
}

const ParamTypesService = {
	getTypeFormat,
};

export default ParamTypesService;
